import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    applicantsGet,
    applicantGetById,
    applicantCreate,
    applicantCreateWithFile,
    applicantUpdate,
    applicantDelete,
    applicantReprocess
} from "api/menu/hr/applicants/requests";

export const APPLICANTS_REQUEST_LOADING = "APPLICANTS_REQUEST_LOADING";
export const APPLICANTS_REQUEST_ERRORS = "APPLICANTS_REQUEST_ERRORS";
export const FETCH_APPLICANTS_SUCCESS = "FETCH_APPLICANTS_SUCCESS";
export const FETCH_APPLICANT_BY_ID_SUCCESS = "FETCH_APPLICANT_BY_ID_SUCCESS";

export const setLoading = () => ({ type: APPLICANTS_REQUEST_LOADING });

export const fetchApplicants = (filters = {}) => dispatch => {
    dispatch(setLoading());
    applicantsGet(filters)
        .then(response => {
            dispatch({ type: FETCH_APPLICANTS_SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, APPLICANTS_REQUEST_ERRORS));
        });
};

export const fetchApplicantById = (id) => dispatch => {
    applicantGetById(id)
        .then(response => {
            dispatch({ type: FETCH_APPLICANT_BY_ID_SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, APPLICANTS_REQUEST_ERRORS));
        });
};

export const createApplicant = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    applicantCreate(data)
        .then(response => {
            dispatch(formErrorLoading(false));
            toast(`Applicant "${data.firstName} ${data.lastName}" created`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(response.data);
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const createApplicantWithFile = (formData, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    applicantCreateWithFile(formData)
        .then(response => {
            dispatch(formErrorLoading(false));
            const firstName = formData.get('FirstName') || '';
            const lastName = formData.get('LastName') || '';
            toast(`Applicant "${firstName} ${lastName}" created with resume`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(response.data);
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateApplicant = (id, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    applicantUpdate(id, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Applicant "${data.firstName} ${data.lastName}" updated`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(true);
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteApplicant = (id, name, callback = false) => dispatch => {
    dispatch(setLoading());
    applicantDelete(id)
        .then(() => {
            toast(`Applicant "${name}" deleted`, { type: toast.TYPE.SUCCESS });
            if (callback) callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, APPLICANTS_REQUEST_ERRORS));
        });
};

export const reprocessApplicant = (id, callback = false) => dispatch => {
    // No dispatch(setLoading()) here to make it non-blocking
    applicantReprocess(id)
        .then(() => {
            toast(`Applicant ${id} reprocessed`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(true);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, APPLICANTS_REQUEST_ERRORS));
            if (callback) callback(error);
        });
};

export const clearApplicants = () => dispatch => {
    dispatch({ type: FETCH_APPLICANTS_SUCCESS, payload: [] });
};

export const clearSingleApplicant = () => dispatch => {
    dispatch({ type: FETCH_APPLICANT_BY_ID_SUCCESS, payload: {} });
};


